<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.groups', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-between">
            <div>
                <div class="inline-flex" :class="selected.length ? 'visible' : 'invisible'">
                    <button
                        class="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                    >
                        {{ $t('messages.download') }}
                    </button>
                    <DropdownButton>
                        <template v-slot:content>
                            <form :action="meta.links.relative_emails_index">
                                <input type="hidden" name="group_ids[]" v-for="g in selected" :value="g" :key="g" />
                                <button
                                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                    type="submit"
                                >
                                    {{ $tc('messages.relatives', 2) }}
                                </button>
                            </form>
                            <form :action="meta.links.student_last_login_index">
                                <input type="hidden" name="group_ids[]" v-for="g in selected" :value="g" :key="g" />
                                <button
                                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                    type="submit"
                                >
                                    {{ $t('messages.last_access') }}
                                </button>
                            </form>
                        </template>
                    </DropdownButton>
                </div>
            </div>

            <AppButton element="InertiaLink" :href="meta.links.create">
                {{ $t('messages.create') }}
            </AppButton>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="w-12 px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <SelectAllNoneButtons
                                        :max-count="groups.data.length"
                                        :selected-count="selected.length"
                                        @select-all="selectAllGroups()"
                                        @select-none="selected = []"
                                        class="inline-flex"
                                    />
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.name') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.students', 2) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(group, index) in groups.data"
                                :key="group.id"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <input
                                        type="checkbox"
                                        name="group"
                                        :value="group.id"
                                        v-model="selected"
                                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                    />
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div class="flex space-x-2 items-center">
                                        <span> {{ group.name }}</span>
                                        <img
                                            v-if="group.image_path"
                                            class="w-12 h-12 object-contain"
                                            :src="group.image_path"
                                            alt=""
                                        />
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ group.students_count }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                >
                                    <InertiaSquareLinkButton action="show" :href="group.links.show" />
                                    <InertiaSquareLinkButton action="edit" :href="group.links.edit" />
                                    <InertiaSquareConfirmActionButton
                                        :href="group.links.delete"
                                        danger
                                        :confirm-text="$t('messages.delete')"
                                        method="delete"
                                        :disabled="!group.can.delete"
                                        :title="
                                            group.students_count
                                                ? `${$t('messages.can_not_be_deleted')} ${$t(
                                                      'messages.it_has_students',
                                                  )}`
                                                : ''
                                        "
                                    >
                                        <template v-slot:icon>
                                            <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                    clip-rule="evenodd"
                                                ></path>
                                            </svg>
                                        </template>
                                        {{ $t('messages.are_you_sure?') }}
                                    </InertiaSquareConfirmActionButton>
                                    <OptionsPanel v-if="group.options.count">
                                        <div v-for="link in group.options.links" :key="link.url">
                                            <div class="mt-3">
                                                <div class="flex flex gap-x-2 items-center">
                                                    <InertiaLink
                                                        :href="link.url"
                                                        class="text-indigo-500 flex gap-x-1 items-center"
                                                    >
                                                        {{ link.title }}

                                                        <IconExternalLink class="h-6 w-6" />
                                                    </InertiaLink>

                                                    <CopyToClipboard :content="link.url" />
                                                </div>
                                                <div class="text-sm text-gray-400">
                                                    {{ link.subtitle }}
                                                </div>
                                            </div>
                                        </div>
                                    </OptionsPanel>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="groups" />
        </template>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareConfirmActionButton from '@/components/InertiaSquareConfirmActionButton.vue';
import OptionsPanel from '@/components/OptionsPanel.vue';
import DropdownButton from '@/components/DropdownButton.vue';
import AppButton from '@/components/AppButton.vue';
import { IconExternalLink } from '@tabler/icons-vue';
import CopyToClipboard from '@/components/CopyToClipboard.vue';
import SelectAllNoneButtons from '@/components/SelectAllNoneButtons.vue';

export default {
    components: {
        SelectAllNoneButtons,
        CopyToClipboard,
        AppButton,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
        InertiaSquareConfirmActionButton,
        OptionsPanel,
        DropdownButton,
        IconExternalLink,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'groups', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
            }),
            selected: [],
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
        selectAllGroups() {
            this.selected = this.groups.data.map((g) => g.id);
        },
    },
};
</script>
